import * as React from 'react';
import { SVGProps } from 'react';

const IconPauseSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M7 2H3v12h4V2zm6 0H9v12h4V2z" />
  </svg>
);
export default IconPauseSizeS;
